// AccountHero — the Manage Account summary hero. Composes the reusable atoms
// (Eyebrow + AsOfPill + Money + StatusPill) on a Surface. Presentational:
// account data in, nothing else. Mirrors the prototype's AccountHero.
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Surface, Eyebrow, AsOfPill, Money } from '../../reusable';
import { CheckIcon } from '../../icons/Icons';

export function AccountHero({ account }) {
  const { t } = useTranslation();
  return (
    <Surface as="section" padding="lg" className="ma-hero">
      <div className="ma-hero__l">
        <div className="ma-hero__eyebrow-row">
          <Eyebrow>{t('manage.hero.eyebrow')}</Eyebrow>
          {account.asOf && <AsOfPill date={account.asOf} />}
        </div>
        <h1 className="ma-hero__title">{t('manage.hero.title')}</h1>
        <p className="ma-hero__sub">
          {t('manage.hero.subtitle')}
        </p>
      </div>

      <div className="ma-hero__r">
        <div className="ma-hero__bal">
          <span className="ma-hero__bal-lbl">{t('manage.hero.totalBalance')}</span>
          <Money value={account.totalBalance} splitCents size="hero" className="ma-hero__bal-val" />
        </div>
        <div className="ma-hero__divider" aria-hidden="true" />
        <div className="ma-hero__vested">
          <span className="ma-hero__bal-lbl">{t('manage.hero.vestedBalance')}</span>
          <Money value={account.vestedBalance} size="lg" className="ma-hero__bal-val ma-hero__bal-val--sm" />
          {account.vestedPct != null && (
            <span className="ma-hero__vested-chip">
              <CheckIcon width={12} height={12} /> {t('manage.hero.pctVested', { pct: account.vestedPct })}
            </span>
          )}
        </div>
      </div>
    </Surface>
  );
}

AccountHero.propTypes = {
  account: PropTypes.shape({
    totalBalance: PropTypes.number,
    vestedBalance: PropTypes.number,
    vestedPct: PropTypes.number,
    status: PropTypes.string,
    asOf: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  }).isRequired,
};

export default AccountHero;
